import { useEffect, useState } from "react";
import { GameData } from "../../../../domain/model/Game";
import { Answer, Question } from "../../../../domain/model/Question";
import { useTranslation } from "react-i18next";
import { useSnackbar } from "notistack";
import {
  getSoundCompletePath,
  SoundRepository,
  Sounds,
} from "../../../../data/repository/sound/SoundRepository";

export function QuestionViewModel() {
  const [gameData, setGameData] = useState<GameData | undefined>();
  const [question, setQuestion] = useState<Question | undefined>();
  const [answer, setAnswer] = useState<Answer | undefined>();

  const { t } = useTranslation();
  const { enqueueSnackbar } = useSnackbar();

  const [countdownTimerSeconds, setCountdownTimerSeconds] =
    useState<number>(-1);

  const [showAnswer, setShowAnswer] = useState<boolean>(false);
  const [hasFirstTeamAnswered, setHasFirstTeamAnswered] =
    useState<boolean>(false);
  const [bothTeamAnswered, setBothTeamAnswered] = useState<boolean>(false);
  const [showWhoAnswered, setShowWhoAnswered] = useState<boolean>(false);
  const [videoFinished, setVideoFinished] = useState<boolean>(false);

  const [timerTicksSoundAudio, setTimerTicksSoundAudio] =
    useState<HTMLAudioElement>();
  const [timerFastTicksSoundAudio, setTimerFastTicksSoundAudio] =
    useState<HTMLAudioElement>();
  const soundRepo = new SoundRepository();

  useEffect(() => {
    if (countdownTimerSeconds == 0) {
      soundRepo.play(getSoundCompletePath(Sounds.timerTimesUp));
    }
    if (countdownTimerSeconds == 5) {
      if (!hasFirstTeamAnswered) {
        stopTimerSounds();
        setTimerTicksSoundAudio(
          soundRepo.play(getSoundCompletePath(Sounds.timerTimerTicks)),
        );
      }
    } else if (countdownTimerSeconds == 2) {
      stopTimerSounds();
      setTimerFastTicksSoundAudio(
        soundRepo.play(getSoundCompletePath(Sounds.timerFastTick)),
      );
    }
  }, [countdownTimerSeconds]);

  function init(gameData: GameData, question: Question, answer: Answer) {
    setGameData(gameData);
    setQuestion(question);
    setAnswer(answer);

    setCountdownTimerSeconds(30);
  }

  function stopTimerSounds() {
    try {
      if (timerTicksSoundAudio) {
        timerTicksSoundAudio.pause();
      }

      if (timerFastTicksSoundAudio) {
        timerFastTicksSoundAudio.pause();
      }
    } catch (ignored) {}
  }

  function onAnswerButtonClicked() {
    soundRepo.play(getSoundCompletePath(Sounds.xAnsweredPop));

    stopTimerSounds();
    if (hasFirstTeamAnswered) {
      setBothTeamAnswered(true);
      setShowAnswer(true);
    } else {
      setHasFirstTeamAnswered(true);
      setCountdownTimerSeconds(10);
    }
  }

  function setTimerPausedOrResumed(isPaused: boolean) {
    if (isPaused) {
      stopTimerSounds();
    }
  }

  function showSnackbar(
    message: string | undefined,
    variant: "error" | "success" | "info" = "error",
  ) {
    if (message) enqueueSnackbar(message, { variant: variant });
  }

  return {
    init,
    question,
    answer,
    gameData,
    countdownTimerSeconds,
    setCountdownTimerSeconds,
    setTimerPausedOrResumed,
    showAnswer,
    setShowAnswer,
    hasFirstTeamAnswered,
    bothTeamAnswered,
    onAnswerButtonClicked,
    showWhoAnswered,
    setShowWhoAnswered,
    videoFinished,
    setVideoFinished,
  };
}
